import { FaBars, FaPlus, FaCalendarAlt } from 'react-icons/fa';
import './Sidebar.css';

export default function Sidebar({ calendars, selectedCalendar, onSelect, onAdd, onShowLink, onDelete, onExport, onShowSettings, isOpen, toggleMenu, onLogout, canRead, canWrite, canDelete }) {

  //filter cals if user has read rights
  const filteredCalendars = calendars.filter(cal => canRead(cal.id));

  console.log('Sidebar render: calendars=', calendars, 'filteredCalendars=', filteredCalendars, 'selectedCalendar=', selectedCalendar);


  return (
    <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <button className="menu-toggle" onClick={toggleMenu}>
        <FaBars />
      </button>

      <button className="add-calendar" onClick={onAdd}>
        <FaPlus className="icon" />
        {isOpen && <span>Neuer Kalender</span>}
      </button>

      <hr />

      <ul className="calendar-list">
        {filteredCalendars.map((cal) => (
          <li
            key={cal.id}
            className={selectedCalendar?.id === cal.id ? 'active' : ''}
            onClick={() => onSelect(cal)}
          >
            <FaCalendarAlt className="icon" />
            {isOpen && <span className='calendar-item-name'>{cal.name}</span>}

            <div
              className="export-btn"
              onClick={(e) => {
                e.stopPropagation();
                // if (window.confirm(`Kalender "${cal.name}" wirklich exportieren?`)) {
                  onExport(cal.id);
                // }
              }}
            >
              📤
            </div>

            <div
              className="link-btn"
              onClick={(e) => {
                e.stopPropagation();
                onShowLink(cal.id);
              }}
            >
              💾
            </div>

            {canWrite(cal.id) && (
              <div
                className="settings-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  onShowSettings(cal.id);
                }}
              >
                ⚙️
              </div>
            )}


            {canDelete(cal.id) && (
              <div
                className="delete-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  if (window.confirm(`Kalender "${cal.name}" wirklich löschen?`)) {
                    onDelete(cal.id);
                  }
                }}
              >
                🗑️
              </div>
            )}

          </li>
        ))}
      </ul>


      <div className="sidebar-footer">
        {isOpen && <button className="logout-btn" onClick={onLogout}>Logout</button>}
      </div>

    </div>
  );
}